<template>
</template>

<script>
    import Http from "@/api/data";
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    export default {
        name: 'HabiteoTracker',
        computed: {
            ...mapGetters([
                'availableTrackings',
                'isOnline',
                'protocol'
            ]),
        },
        mounted() {
            // Pixel tracking
            EventBus.$on('trackWidget', (trackingData) => {
                if (trackingData && this.isOnline && this.availableTrackings.habiteo)
                    Habiteo.track(trackingData);
            });

            // Events tracking
            EventBus.$on('trackingEvent', (trackingData, event) => {
                if (this.availableTrackings.habiteo && this.isOnline)
                    this.trackEvent(trackingData, event);
            });
        },
        methods: {
            trackEvent(trackingData, event) {
                let urlLink = this.protocol + process.env.API_LIST.FO + '/tracking?id=' + trackingData.id + '&key=' + trackingData.key;
                urlLink += trackingData.view ? '&view=' + trackingData.view : '';
                urlLink += trackingData.alternateModel ? '&alternateModel=' + trackingData.alternateModel : '';
                urlLink += 'mode' in this.$route.query ? '&mode=' + this.$route.query.mode : '';
                urlLink += event ? '&event=' + event : '';
                Http.getData(urlLink).then(payload => {
                    console.log(payload);
                }).catch(error => {
                    console.error('Blocked by client. More details : ', error);
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/components/HabiteoTracker.vue